export interface CompositeFilter {
  predicates: CompositePredicate[]
}

export type Predicate = CompositePredicate | SimplePredicate

export type Combinator = 'AND' | 'OR';

export interface CompositePredicate {
  id?: string
  combinator: Combinator
  predicates: Predicate[]
}

export type OrgUnitsTypes = 'Organization' | 'Service' | 'Team';

export type SimplePredicate = OrgUnitPredicate | TagPredicate;

export interface OrgUnitPredicate {
  id: string
  org_unit_type: OrgUnitsTypes
  org_unit_value?: string
}

export interface TagPredicate {
  id?: string
  org_unit_type: 'tag'
  org_unit_value?: string
}

export const isSimplePredicate = (filter: Predicate): filter is SimplePredicate => {
  return (filter as SimplePredicate).org_unit_type !== undefined;
}

export const isTagPredicate = (filter: Predicate): filter is TagPredicate => {
  return (filter as SimplePredicate).org_unit_type === 'tag';
}

export const isOrgUnitPredicate = (filter: Predicate): filter is OrgUnitPredicate => {
  return (filter as SimplePredicate).org_unit_type !== 'tag';
}

export const isCompositePredicate = (filter: Predicate): filter is CompositePredicate => {
  return (filter as CompositePredicate).combinator !== undefined;
}

export interface AllowedOrgUnit {
  id: string
  name: string
  type: OrgUnitsTypes
  eligible: boolean
}

export interface AllowedOrgUnits {
  type: OrgUnitsTypes | 'tag'
  values: AllowedOrgUnit[]
}